module.exports = __webpack_public_path__ + "static/media/success.bf2ede12.svg";